// extracted by mini-css-extract-plugin
module.exports = {"upload":"_3p4nlOLuP3qN-iot_KjhDv","courseUpload":"_2_Ut_kWU9lRqYvy1q2Qj7s"};